type RatingInfoProps = {
  google_rating: number
}

export const RatingInfo = ({ google_rating }: RatingInfoProps) => {
  return (
    <section className='row'>
      <img
        src={'/ilp-public/assets/images/star.png'}
        className='icon'
        alt={`Google rating is  ${google_rating}`}
      />
      <p className='subTitle'>{`${google_rating.toFixed(1)}`}</p>
      <style jsx>{`
        .subTitle {
          line-height: 24px;
          font-size: 16px;
          font-weight: 500;
        }
        .icon {
          margin-right: 5px;
          height: 16px;
          width: 16px;
        }
        .row {
          display: flex;
          fexl-direction: row;
          align-items: center;
        }
      `}</style>
    </section>
  )
}
